(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$scope', '$state', 'Company', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'CompanyCustomService'];

    function CompanyController ($scope, $state, Company, ParseLinks, AlertService, pagingParams, paginationConstants, CompanyCustomService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.clear = clear;

        loadAll();

        function loadAll () {
            Company.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery || searchQuery.length === 0){
                vm.loadPage(1);
            }
            vm.currentSearch = searchQuery;
            CompanyCustomService.returnSearchCompanies(vm.currentSearch).then( function( data ) {
                vm.companies = data.data;
                vm.totalItems = vm.companies.length;
                vm.queryCount = vm.totalItems;
                vm.page = 1;
            }, function( error ) {
                vm.companies = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.page = 1;
            });
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.loadAll()
        }

        vm.createTab = function( data ) {
            $scope.$emit('handleEmit', data );
        }
    }
})();
